module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9D0SQk/tc-custom/9781646566655.jpg?1723403959715",
      "alt": "This image is the cover for the book The Night Belongs to Us"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Night Belongs to Us\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It doesn’t come as much of a surprise to Alex Ryan when she finds herself falling head over heels for Connie O’Reilly. How could she not? There isn’t a person alive who wouldn’t be drawn to the irresistibly beautiful and charming Connie. It seems impossible she could reciprocate -- not when Alex is so awkward, so timid, so very much a girl -- until what starts as a sweet friendship blossoms into something so much more than Alex could have dreamed of."), _c('br'), _c('br'), _vm._v("Alex knows what they have is a momentary thing, not enough to be called forever. Connie’s the most popular girl in the school, wealthy and admired. She’s going to go to Trinity, maybe marry a lawyer. She’s going to have everything Alex could never give her. She isn’t stupid, after all."), _c('br'), _c('br'), _vm._v("Status and reputation might mean nothing to Alex, but to Connie they are everything. The only out-lesbian they know is ridiculed by everyone she meets, and it’ll be a cold day in hell before Connie lets that be her."), _c('br'), _c('br'), _vm._v("But when rumours spark and new faces enter the picture, they’re both set to discover that, while it may be easy to walk away, it’s a lot harder to move on.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katie Brown\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0